module.exports = __webpack_public_path__ + "/login_ui/img/baby-club-89b794381b267262d926efbac0398de1.svg";